export class DeepLinkTypesModel {
  public static sso = 'sso';
  public static integration = 'integration';

  public static list(): string[] {

    return [
      this.sso,
      this.integration
    ];
  }

}
